import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { SharedModule } from '../shared.module';
import { UfCidadeSelectModule } from '../uf-cidade-select/uf-cidade-select.module';
import { DirectivesModule } from './../../directives/directives.module';
import { TextDirectivesModule } from './../../directives/texto/text.directives.module';
import { LoadersModule } from './../loaders/loaders.module';
import { EnderecoComponent } from './endereco.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ModalMultiplosEnderecosComponent } from './modal-multiplos-enderecos/modal-multiplos-enderecos.component';
import { ModalEncontrarCepComponent } from './modal-encontrar-cep/modal-encontrar-cep.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    SharedModule,
    NgxMaskModule.forRoot(),
    TextDirectivesModule,
    UfCidadeSelectModule,
    LoadersModule,
    ModalModule.forRoot(),
    ReactiveFormsModule
  ],
  declarations: [
    EnderecoComponent,
    ModalMultiplosEnderecosComponent,
    ModalEncontrarCepComponent,
  ],
  entryComponents: [
    ModalMultiplosEnderecosComponent,
    ModalEncontrarCepComponent,
  ],
  exports: [EnderecoComponent],
  providers: []
})
export class EnderecoModule { }
